<!--，默认内容-->
<template>
  <div class="info-content">
    <div class="change-point" v-if="activeIndex=='96'">
      <el-link class="link-left" icon="el-icon-location" :underline="false">{{ childNode.name }}</el-link>
      <el-popover placement="left-start" title="" popper-class="popper" style="max-width: 300px;">
        <div>
          <p>切换城市</p>
          <el-button round v-for="item of childNodes" @click="changeCity(item)">{{ item.name }}</el-button>
        </div>
        <span slot="reference" class="switchCity" style="color: #ffffff;font-size: 14px;">切换城市<i
            class="el-icon-arrow-down"/> </span>
      </el-popover>
    </div>
    <el-container>
      <el-aside class="content-list">
        <div class="info-list" v-for="base of dataBase" @click="details(base)" v-if="base.type!=3">
          <div v-if="base.photo.length<1">
            <p class="span-bold" v-if="base.title!=''">{{ base.title }}</p>
            <p class="span-bold" v-else>{{ base.keyword }}</p>
            <p>
              <span v-if="base.is_top==1" class="span-red">置顶</span>
              <span class="span-default">{{ base.user_name }}</span>
              <span class="span-default">{{ base.time }}</span>
            </p>
          </div>
          <div v-else-if="base.photo.length<3">
            <el-row>
              <el-col :span="5">
                <el-image :src="base.photo[0]" style="height: 110px;width: 100%" fit="cover"/>
                <i class="iconfont icon-bofang" v-if="base.type==2"/>
              </el-col>
              <el-col :span="19" style="padding-left: 10px;">
                <p class="span-bold" v-if="base.title!=''">{{ base.title }}</p>
                <p class="span-bold" v-else>{{ base.keyword }}</p>
                <p>
                  <span v-if="base.is_top==1" class="span-red">置顶</span>
                  <span class="span-default">{{ base.user_name }}</span>
                  <span class="span-default">{{ base.time }}</span>
                </p>
              </el-col>
            </el-row>
          </div>
          <div v-else>
            <p class="span-bold" v-if="base.title!=''">{{ base.title }}</p>
            <p class="span-bold" v-else>{{ base.keyword }}</p>
            <el-row>
              <el-col :span="5" v-for="(photo,index) of base.photo" v-if="index<3" class="imgs">
                <el-image :src="photo" style="height: 110px;width: 100%" fit="cover"/>
              </el-col>
            </el-row>
            <p>
              <span v-if="base.is_top==1" class="span-red">置顶</span>
              <span class="span-default">{{ base.user_name }}</span>
              <span class="span-default">{{ base.time }}</span>
            </p>
          </div>
        </div>
      </el-aside>
      <el-main :class="mainClass" v-if="CustomInfo.status!=1">
        <openCloud/>
      </el-main>
    </el-container>
    <!-- 分页 -->
    <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>
  </div>
</template>

<script>
import openCloud from "@/components/children/openCloud";
import page from "@/components/page/pages";
import {recommendLists} from "@/api/interfaceApi";
import chinaCode from '@/static/chinaCode.json'
import $store from "@/store";

export default {
  name: "defaultInfo",
  components: {openCloud, page},
  data() {
    return {
      dataBase: [],
      cid: 0,
      mainClass: 'cloud',
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      CustomInfo: {},
      lng:'',
      lat:'',
    }
  },
  props: {
    activeIndex: {
      type: String,
      default() {
        return '2'
      }
    },
    activeTabs: {
      type: Object,
      default() {
        return {
          epidemic_url: "",
          image: "",
          is_epidemic: 0,
          is_local: 0,
          name: "推荐",
          nid: '2',
          no: 0,
        };
      }
    },
    cityList: {
      type: Object,
      default() {
        return {
          id: 500000,
          lat: 29.533155,
          level: 1,
          lng: 106.504959,
          name: "重庆",
          pid: 0,
          short_name: "重庆"
        }
      }
    }
  },
  computed: {
    childNode() {
      return $store.state.childNode
    },
    childNodes(){
      return $store.state.childNodes
    }
  },
  watch: {
    activeIndex: function (val, oldVal) {
      this.tablePage.currentPage = 1;
      this.getInfo();
    }
  },
  methods: {
    /*查看详情*/
    details(row) {
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (row.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query: {
            id: row.id,
            type: row.type,
          },
          params: {cid: this.cid},
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else if (row.type == 1 && row.method_type == 'policy') {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query: {
            id: row.id,
            type: 3,
          },
          params: {cid: this.cid},
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      } else {
        if (row.cid == 0) {
          let routeData = this.$router.resolve({
            name: "articleDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/articleDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "dynamic") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.method_type == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.method_type == "article") {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: row.id,
              type: 1,
            },
            params: {cid: this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: row.id,
              type: row.type,
            },
            params: {cid: this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getInfo();
    },
    /*获取列表数据*/
    getInfo() {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      recommendLists({
        advLat: this.lng ? this.lng: this.cityList.lng,
        advLng: this.lat ? this.lat: this.cityList.lat,
        advNetwork: 4,
        advPlatform: 3,
        city: parseInt(this.activeIndex)==96 ? this.childNode.cityCode : this.childNode.parentCityCode,
        nid: parseInt(this.activeIndex) == 2 ? 0 : parseInt(this.activeIndex),
        page: this.tablePage.currentPage,
        uid: cid != 0 && cid != undefined ? cid : 0,
        cid: cid != 0 && cid != undefined ? cid : 0
      }).then(res => {
        if (res.code == 200) {
          window.scrollTo(0, 0);
          this.dataBase = res.content;
          this.tablePage.total = res.total;
        }
      })
    },
    /*切换城市*/
    changeCity(city) {
      for (let row of chinaCode) {
        if (city.cityCode == row.adcode) {
          this.lng=row.lng;
          this.lat=row.lat;
        }
      }
      $store.commit('SET_CHILD_NODE', JSON.stringify(city));
      this.$emit('changeCity',  JSON.stringify(city));
      this.getInfo();
    }
  },
  mounted() {
    this.getInfo();
  },
  beforeMount() {
    this.CustomInfo = sessionStorage.getItem('CustomInfo') ? JSON.parse(sessionStorage.getItem('CustomInfo')) : {};
    for (let row of chinaCode) {
      if (this.childNode.cityCode == row.adcode) {
        this.lng=row.lng;
        this.lat=row.lat;
      }
    }
  }
}
</script>
<style scoped>
.info-content >>> .el-card__body, .el-main {
  padding: 20px 0px 0px 10px;
}
</style>
<style scoped lang="scss">
.info-content {
  .content-list {
    width: 75% !important;

    .info-list {
      padding: 15px 0px;

      .span-bold {
        font-size: 20px;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
      }

      .p-bold {
        font-size: 18px;
        font-weight: 100;
        font-family: 'SourceHanSansCN';
        color: #333;
        margin-block-start: 0em;
        margin-block-end: 0em;
        min-height: 80px;
      }

      .imgs {
        margin-right: 10px;
        margin-top: 10px;
      }

      p {
        font-size: 16px;
        margin-block-start: 10px;
        margin-block-end: 10px;

        .span-red {
          color: #FE273B;
          font-size: 14px;
          padding-right: 20px;
          font-weight: 100;
          font-family: 'SourceHanSansCN';
        }

        .span-default {
          color: #999999;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          font-weight: 100;
          padding-right: 20px;
        }
      }

      .icon-bofang {
        font-size: 30px;
        color: white;
        margin-top: 4.5%;
        position: absolute;
        margin-left: -12.2%;
      }
    }
  }

  .fiexd-cloud {
    position: fixed;
    top: 15%;
    right: 18%;
    width: 314px;
  }

  .change-point {
    background: url("~@/assets/img/childCode.png") no-repeat;
    width: 100%;
    background-size: 100% 100%;
    padding: 27px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .link-left {
      color: #ffffff;
    }
  }
}
</style>
<style>
.el-popover {
  max-width: 450px !important;
}
</style>